import { render } from "./ContentFileUpload.vue?vue&type=template&id=4f030407"
import script from "./ContentFileUpload.vue?vue&type=script&lang=js"
export * from "./ContentFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__